import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    countries: [],
    countriesMetadata: {},
    country: {},
    countryMetadata: {}
  }
})
  .get({
    action: 'getCountries',
    property: 'countries',
    queryParams: true,
    path: '/countries/',
    onSuccess: payloadToState('countries')
  })
  .post({
    action: 'createCountry',
    property: 'country',
    path: '/countries/',
    onSuccess: payloadToState('country')
  })
  .get({
    action: 'getCountry',
    property: 'country',
    path: ({ id }) => `/countries/${id}`,
    onSuccess: payloadToState('country')
  })
  .put({
    action: 'updateCountry',
    property: 'country',
    path: ({ id }) => `/countries/${id}`,
    onSuccess: payloadToState('country')
  })
  .delete({
    action: 'deleteCountry',
    property: 'country',
    path: ({ id }) => `/countries/${id}`,
    beforeRequest: getOptimisticDelete('countries'),
    onSuccess: payloadToState('country')
  })
  .getStore()
